import React from 'react';
import { Tooltip, Typography, SxProps, Theme, TypographyTypeMap } from '@mui/material';
import { useTranslation } from "react-i18next";
import { i18n } from 'i18next';

export function toISOPercent(i18n: i18n, value: number, options?: Intl.NumberFormatOptions) {
  const result = i18n.t("intlNumber", {
    maximumFractionDigits: 2,
    maximumSignificantDigits: 3,
    roundingPriority: "lessPrecision",
    ...options,
    style: "percent",
    val: value
  });
  return result;
}

export interface ISOPercentageProps {
  typographyVariant?: TypographyTypeMap | string;
  value: number;
  options?: Intl.NumberFormatOptions;
  hideTooltip?: boolean;
  sx?: SxProps<Theme> | undefined;
}

export default function ISOPercentage(props: ISOPercentageProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const variant: any = props.typographyVariant || "body1";
  const value = toISOPercent(i18n, props.value, props.options);
  const valueAsPercent = `${value}`;

  return (
    <>
      {!props.hideTooltip && 
        <Tooltip title={valueAsPercent} followCursor={true}>
          <Typography variant={variant} component="span" sx={props.sx} >
            {valueAsPercent}
          </Typography>
        </Tooltip>
      }
      {props.hideTooltip && 
        <Typography variant={variant} component="span" sx={props.sx} >
          {valueAsPercent}
        </Typography>
      }
    </>
  );
}